export default __webpack_public_path__ + "/dist/images/logo2.68a143138d1372a39ed5f3a31a508e57.png";